import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Icon, List } from '@pella/sash-framework';
import { Image } from '../..';

const ImageWithClickPoints = ({ data, icon = 'add', darkMode, className }) => {
	return (
		<div className={`image-popout text-center ${className || ''}`}>
			{data?.heading && (
				<h2
					className={`mb-5 text-center ${darkMode ? 'text-white' : ''}`}
					dangerouslySetInnerHTML={{ __html: data.heading }}
				/>
			)}

			<div className='relative inline-block'>
				{data?.image?.[0] && <Image data={data.image[0]} />}

				{data?.popouts?.[0] && (
					<List bullets='none'>
						{data.popouts.map((popout, index) => {
							const isRight = popout.position_horizontal?.slice(0, 2) >= 60;
							const isLeft = popout.position_horizontal?.slice(0, 2) <= 35;

							return (
								<li
									key={index}
									style={{ top: popout.position_vertical, left: popout.position_horizontal }}
									className='absolute'
								>
									<Dropdown>
										<Dropdown.Trigger className='pointer-events-none flex h-8 w-8 items-center justify-center rounded-full bg-primary shadow-lg lg:h-10 lg:w-10'>
											<Icon
												name={icon}
												size={32}
												className='block max-lg:!text-2xl'
											/>
										</Dropdown.Trigger>

										<Dropdown.Content className={`z-3 mt-1 !block w-max !px-3 !py-1 ${isLeft ? '-left-2 md:left-0 xl:left-1/2 xl:-translate-x-1/2' : isRight ? '!left-auto -right-2 md:right-0 xl:right-1/2 xl:translate-x-1/2' : 'left-1/2 -translate-x-1/2'}`}>
											{popout.file && <Image data={{ image: popout.file }} />}
											{popout.heading && <p className='text-base font-semibold xl:text-3xl'>{popout.heading}</p>}

											{popout.description && (
												<div
													className='text-sm !leading-tight'
													dangerouslySetInnerHTML={{ __html: popout.description }}
												/>
											)}
										</Dropdown.Content>
									</Dropdown>
								</li>
							);
						})}
					</List>
				)}
			</div>
		</div>
	);
};

ImageWithClickPoints.propTypes = {
	data: PropTypes.object.isRequired,
	icon: PropTypes.string,
	className: PropTypes.string,
	darkMode: PropTypes.bool,
};

export default ImageWithClickPoints;
